export default __webpack_public_path__ + "static/media/ic_precio_farmacia.b7ab1b32.svg";